// extracted by mini-css-extract-plugin
export var circle = "_ai-1";
export var exitConfirmationModal = "_ai-5";
export var iframe = "_ai-0";
export var offline = "_ai-3";
export var online = "_ai-2";
export var workstationSelectError = "_ai-4";